import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { saveButtonAriaLabel } from '../../helpers';
import { Stamp } from '../../models';
import { ButtonComponent, DeferLoadDirective, IconCircleComponent } from '@woolworthsnz/styleguide';
import { NgClass } from '@angular/common';

export interface StampBasicInput {
	title: string;
	link: string;
	imageUrl: string;
	imageFallbackUrl: string;
}

@Component({
	selector: 'recipe-stamp-basic',
	templateUrl: './stamp-basic.component.html',
	styleUrls: ['./stamp-basic.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [DeferLoadDirective, NgClass, ButtonComponent, IconCircleComponent]
})
export class StampBasicComponent {
	@Input() stamp: Stamp;
	@Input() link: string;
	@Output() public saveOrUnsaveRecipe = new EventEmitter<{ id: number; isSaved: boolean }>();

	public imageLoading = true;

	get fallbackImageUrl(): string {
		return `/images/recipe_unavailable.svg`;
	}

	get saveButtonAriaLabel(): string {
		return saveButtonAriaLabel(this.stamp.recipe.title, !!this.stamp.recipe.saved);
	}
}
